"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = void 0;

var tslib_1 = require("tslib");

var _uniq = require("lodash/uniq");

var common_1 = require("../../utils/common");

exports.search = function (query, certificates) {
  var queryWords = _uniq(common_1.escapeRegExp(query) // убираем все regext символы из строки поиска
  .split(/\s/).filter(Boolean) // убираем все пробелы
  .map(function (item) {
    return item.toLowerCase();
  }));

  var queryWordsCount = queryWords.length;
  var cyrillicDublicates = queryWords.map(function (part) {
    return latinToCyrillic(part);
  }).filter(Boolean);
  queryWords = queryWords.concat(cyrillicDublicates);
  queryWords = queryWords.sort().reverse(); // сначала будем искать по длинным подстрокам

  var re = new RegExp(queryWords.join('|'), 'ig');
  var result = {};
  certificates.forEach(function (c) {
    var matchedInfo = {
      matched: {},
      matchCount: 0
    };
    var fullMatchResult = [];

    var searchInField = function searchInField(fieldName, fieldValue) {
      var matchResult = fieldValue.match(re);

      if (matchResult) {
        matchResult = _uniq(matchResult.map(function (item) {
          return item.toLowerCase();
        }));
        fullMatchResult = fullMatchResult.concat(matchResult);
        matchedInfo.matchCount += matchResult.length;
        matchedInfo.matched[fieldName] = matchResult;
      }
    };

    searchInField('organizationName', c.organizationName());
    searchInField('owner', c.owner());
    searchInField('inn', c.inn());
    searchInField('kpp', c.kpp());

    if (_uniq(fullMatchResult).length === queryWordsCount) {
      result[c.thumbprint()] = matchedInfo;
    }
  });
  return result;
};

var latinLetters = "qwertyuiop[]asdfghjkl;'zxcvbnm,./".split('');
var cyrillicLetters = 'йцукенгшщзхъфывапролджэячсмитьбю.'.split('');
var dictionary = latinLetters.reduce(function (acc, letter, index) {
  var _a;

  return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[letter] = cyrillicLetters[index], _a));
}, {});

var latinToCyrillic = function latinToCyrillic(latin) {
  var ru = latin.split('').map(function (letter) {
    return dictionary[letter] || letter;
  }).join('');
  return ru !== latin ? ru : '';
};